import { AuthMutationTypes } from '@/store/modules/auth/AuthMutationTypes'

export interface State {
  error: string | null
  pending: boolean
}

const initialState: State = {
  error: null,
  pending: false,
}

export default {
  state: initialState,
  getters: {
    getLoginPageError(state: State) {
      return state.error
    },
    getLoginPagePending(state: State) {
      return state.pending
    },
  },
  mutations: {
    [AuthMutationTypes.Login](state: State) {
      state.pending = true
      state.error = null
    },
    [AuthMutationTypes.LoginSuccess](state: State) {
      state.pending = false
    },
    [AuthMutationTypes.LoginFailure](state: State, error: string) {
      state.pending = false
      state.error = error
    },
  },
}
